import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeatureAccessoryListClasses = 'container';

const featureAccessoryListStyles = makeStyles<ISpcTheme, FeatureAccessoryListClasses>(
  () => ({
    container: {
      padding: '15px 0 0',
    },
  }),
  { name: 'Customise_Feature_AccessoryList' },
);

export default featureAccessoryListStyles;
